import * as actions from "../action.constants";

const storeCreateTemplateData = (data) => ({
  type: actions.STORE_CREATE_TEMPLATE_DATA,
  payload: data,
});

const requestTemplates = () => ({
  type: actions.REQUEST_TEMPLATES,
});

const requestEachTemplates = (id) => ({
  type: actions.REQUEST_EACH_TEMPLATE,
  id,
});

const storeTemplates = (data) => ({
  type: actions.STORE_TEMPLATES,
  payload: data,
});

const createTemplate = (data, callback) => ({
  type: actions.CREATE_TEMPLATE,
  payload: data,
  callback,
});

const deleteTemplate = (id, callback) => ({
  type: actions.DELETE_TEMPLATE,
  id,
  callback,
});

const requestTemplateControllers = (all) => ({
  type: actions.REQUEST_TEMPLATE_CONTROLLERS,
  all,
});

const storeTemplateControllers = (data) => ({
  type: actions.STORE_TEMPLATE_CONTROLLERS,
  payload: data,
});

const requestNonTestTemplate = (id) => ({
  type: actions.REQUEST_NON_TEST_TEMPLATE,
  id,
});

const storeNonTestTemplate = (data) => ({
  type: actions.STORE_NON_TEST_TEMPLATE,
  payload: data,
});

const createNonTestTemplate = (data, callback) => ({
  type: actions.CREATE_NON_TEST_TEMPLATE,
  payload: data,
  callback,
});

const setNonTestFormVisibility = (data) => ({
  type: actions.NON_TEST_FORM_VISIBLE,
  payload: data,
});

const storeCreateNonTestData = (data) => ({
  type: actions.STORE_CREATE_NON_TEST_DATA,
  payload: data,
});

const requestTestSensors = (mac) => ({
  type: actions.REQUEST_TEST_SENSORS,
  mac,
});

const storeTestSensors = (data) => ({
  type: actions.STORE_TEST_SENSORS,
  payload: data,
});

const setTestFormVisibility = (data) => ({
  type: actions.TEST_FORM_VISIBLE,
  payload: data,
});

const storeCreateTestData = (data) => ({
  type: actions.STORE_CREATE_TEST_DATA,
  payload: data,
});

const storeTestTemplateList = (data) => ({
  type: actions.STORE_TEST_TEMPLATE_LIST,
  payload: data,
});

const requestReportSites = () => ({
  type: actions.REQUEST_REPORTS_SITES,
});

const storeReportSites = (data) => ({
  type: actions.STORE_REPORTS_SITES,
  payload: data,
});

const requestReportLocations = (site) => ({
  type: actions.REQUEST_REPORTS_LOCATIONS,
  site,
});

const storeReportLocations = (data) => ({
  type: actions.STORE_REPORTS_LOCATIONS,
  payload: data,
});

const requestReportControllers = (location) => ({
  type: actions.REQUEST_REPORT_CONTROLLERS,
  location,
});

const storeReportControllers = (data) => ({
  type: actions.STORE_REPORT_CONTROLLERS,
  payload: data,
});

const storeReportSelectedControllerList = (data) => ({
  type: actions.STORE_REPORT_SELECTED_CONTROLLERS_LIST,
  payload: data,
});

const requestRecord = (mac, callback) => ({
  type: actions.REQUEST_RECORD,
  mac,
  callback,
});

const storeCreateReportData = (data = {}) => ({
  type: actions.STORE_CREATE_REPORT_DATA,
  payload: data,
});

const createReport = (payload, callback) => ({
  type: actions.REQUEST_CREATE_REPORT,
  payload,
  callback,
});

const requestReports = (pageUrl) => ({
  type: actions.REQUEST_REPORTS_SAGA,
  pageUrl,
});

const storeReports = (data) => ({
  type: actions.STORE_REPORTS,
  payload: data,
});

const requestEachReport = (id) => ({
  type: actions.REQUEST_EACH_REPORT,
  id,
});

const changeReportStatus = (id, status, callback) => ({
  type: actions.CHANGE_REPORT_STATUS,
  id,
  status,
  callback,
});

const requestReportAnalysis = (id, callback) => ({
  type: actions.REQUEST_REPORT_ANALYSIS,
  id,
  callback,
});

const requestReportPDF = (id) => ({
  type: actions.REQUEST_REPORT_PDF,
  id,
});

const deleteReport = (id, callback) => ({
  type: actions.DELETE_REPORT,
  id,
  callback,
});

export {
  requestTemplateControllers,
  storeTemplateControllers,
  requestTestSensors,
  storeTestSensors,
  createNonTestTemplate,
  storeNonTestTemplate,
  storeTestTemplateList,
  requestNonTestTemplate,
  storeCreateTemplateData,
  storeCreateNonTestData,
  storeCreateTestData,
  setTestFormVisibility,
  setNonTestFormVisibility,
  storeReportSelectedControllerList,
  createTemplate,
  requestTemplates,
  storeTemplates,
  requestEachTemplates,
  deleteTemplate,
  requestReportSites,
  storeReportSites,
  requestReportLocations,
  storeReportLocations,
  requestReportControllers,
  storeReportControllers,
  requestRecord,
  storeCreateReportData,
  createReport,
  requestReports,
  storeReports,
  requestEachReport,
  changeReportStatus,
  requestReportAnalysis,
  requestReportPDF,
  deleteReport,
};
